<template>
    <div class="company-merge">
        <data-form title="Merge Companies"
                   tag="company-merge"
                   save-button-label="Submit"
                   :field-model="mergeModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/company/list"
                   submit-success-message="Companies merged"
                   submit-error-message="Error merging companies">
        </data-form>
    </div>
</template>

<script>
import Vue from 'vue'
import Company from '@/models/Company'
import {required} from 'vuelidate/lib/validators'

export default Vue.extend({
    name: 'CompanyMerge',
    data () {
        return {
            mergeModel: {
                fields: {
                    company_id: {
                        label: 'Master Company',
                        type: 'typeahead',
                        options: [],
                        async loadOptions (model) {
                            Company.loadCompanyOptions(this)
                        },
                        validations: { required }
                    },
                    merge_company_id: {
                        label: 'Duplicate Company',
                        type: 'typeahead',
                        options: [],
                        async loadOptions (model) {
                            Company.loadCompanyOptions(this)
                        },
                        validations: { required }
                    },
                },
            },
            fieldGroups: [
                ['company_id'],
                ['merge_company_id'],
            ],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            console.log('CompanyMerge:onSubmit  modelInstance=', modelInstance);
            if (modelInstance.company_id === modelInstance.merge_company_id) {
                throw 'You have selected the same company';
            } else {
                return this.$bvModal.msgBoxConfirm('Are you sure you wish to merge the companies?')
                    .then((ok) => {
                        if (ok) {
                            // merge companies
                            return this.$api.mergeCompanies(this, modelInstance.company_id, modelInstance.merge_company_id)
                                .then(() => {
                                    // forward to company view
                                    this.$router.push(`/company/view/${modelInstance.company_id}`)
                                })
                        } else {
                            throw 'Merging not cmopleted'
                        }
                    })
            }
        }
    }
})
</script>
